export default {
  'universal-layout.topmenu.userinfo': 'Personal Info',
  'universal-layout.topmenu.logout': 'Logout',

  'universal-layout.menu.home': 'Home',
  'universal-layout.menu.home.workplace': 'Workplace',
  'universal-layout.menu.home.custom-breadcrumbs': 'Custom bread crumbs',
  'universal-layout.menu.home.custom-breadcrumbs.liqingsong.cc': 'liqingsong.cc',
  'universal-layout.menu.home.docs': 'Using document',

  'universal-layout.menu.component': 'Component',
  'universal-layout.menu.component.icon': 'Icon',
  'universal-layout.menu.component.icon.svg': 'IconSvg',
  'universal-layout.menu.component.icon.font': 'IconFont',
  'universal-layout.menu.component.editor': 'Editor',
  'universal-layout.menu.component.editor.tui-editor': 'tui-editor',
  'universal-layout.menu.component.editor.ckeditor': 'CKEditor',

  'universal-layout.menu.pages': 'Page sample',
  'universal-layout.menu.pages.list': 'List page',
  'universal-layout.menu.pages.list.basic': 'Basis list',
  'universal-layout.menu.pages.list.table': 'Table list',
  'universal-layout.menu.pages.list.highly-adaptive-table': 'Highly adaptive table',
  'universal-layout.menu.pages.list.search': 'Search list',
  'universal-layout.menu.pages.list.search.table': 'Query list',
  'universal-layout.menu.pages.form': 'Form page',
  'universal-layout.menu.pages.form.basic': 'Basis Form',
  'universal-layout.menu.pages.form.complex': 'Advanced Form',
  'universal-layout.menu.pages.detail': 'Details page',
  'universal-layout.menu.pages.detail.basic': 'Basic details',
  'universal-layout.menu.pages.detail.module': 'Module details',
  'universal-layout.menu.pages.detail.table': 'Table details',

  'universal-layout.menu.roles': 'Permission to verify',
  'universal-layout.menu.roles.all': 'All users have permissions',
  'universal-layout.menu.roles.user': 'Users have permission',
  'universal-layout.menu.roles.test': 'Tests have permission',
};
